<template>
  <section class="section fast-access">
    <h2 class="section-heading">
      Not So Good <span class="text-accent">Team</span>
    </h2>
    <ul class="team-list">
      <template v-for="member in members">
        <PlayerCard
          v-on:render-profile="$emit('render-profile')"
          :key="member.id"
          :member="member"
        />
      </template>
    </ul>
  </section>
</template>

<script>
import PlayerCard from "./PlayerCard.vue";

export default {
  name: "TeamList",
  components: {
    PlayerCard
  },
  data() {
    return {
      members: [
        {
          id: 1,
          nick: "MientusM",
          faceit_id: "dc483a07-2ba9-4147-9b6a-170739046213"
        },
        {
          id: 2,
          nick: "Drzemol",
          faceit_id: "8f36179c-202b-4ac5-8cad-311f9451189b"
        },
        {
          id: 3,
          nick: "HornyNippel",
          faceit_id: "9d09c1f6-f132-4476-9a40-fa2b90d7a49a"
        },
        {
          id: 4,
          nick: "LuckGo",
          faceit_id: "b4cbee31-96d9-4458-8b9a-d5b8e763a1af"
        },
        {
          id: 5,
          nick: "Mosquit069",
          faceit_id: "a1dd5d16-f1b2-4608-9dbb-a4e1eea2dd6b"
        },
        {
          id: 6,
          nick: "Baton99",
          faceit_id: "fa1b4775-c887-4af1-bd67-72c0e2b98a17"
        }
      ]
    };
  }
};
</script>
